export default {
  title: 'Délai de connection dépassé',
  message: 'Veuillez fermer la fenêtre et réessayer',
};
